
  const dadosSessoes = [
    {
    id: 1,
    url: '/static/photos-exercises/lombalgia-aguda.png',
    title: 'Fase 1',
    width: '33%',
    text: 'Plano particularmente adequado a situações em que os sintomas apresentam manifestação com duração inferior a quatro semanas, geralmente em fase inicial do desenvolvimento da patologia.',
    exercises: [
        {
            ordem: 1,
            name: 'Posição de prece',
            tipo: 'Manutenção de postura',
            category: ['Alongamento'],
            url: '/static/photos-exercises/1-posicaoprece.png',
            reps: 2,
            series: 5,
            descansoAposSerie: 1,
            descansoAposExercicio: 30,
            urlVideo: 'https://www.youtube.com/embed/4lXqo3oZNGs',
            tempoLimite: 130,
            tempoManutencao: 5,
            intensidade: 'Intermédio',
            membros: ['Tronco'],
            instrucoes: [
                {
                    ordem: 1,
                    instrucao: 'Inicie em quatro apoios e sente-se sobre os calcanhares.'
                },
                {
                    ordem: 2,
                    instrucao: 'Estenda os braços para a frente, baixando a cabeça entre os ombros em direção ao chão. Deverá sentir um alongamento nas costas e nos braços. '
                }
            ]
        },
        {   
            ordem: 2,
            name: 'Ponte de Glúteos',
            tipo: 'Repetições',
            category: ['Reforço Muscular'],
            url: '/static/photos-exercises/2-ponteGluteos.png',
            reps: 4,
            series: 1,
            descansoAposSerie: 10,
            descansoAposExercicio: 20,
            urlVideo: 'https://www.youtube.com/embed/mK-2Pcz8-mA',
            tempoLimite: 'N.D',
            tempoManutencao: 'N.D',
            intensidade: 'Elementar',
            membros: ['Membros Inferiores', 'Tronco'],
            instrucoes: [
                {
                    ordem: 1,
                    instrucao: 'Deite-se de barriga para cima com os joelhos dobrados e os pés apoiados no chão. '
                },
                {
                    ordem: 2,
                    instrucao: 'Contraia os glúteos e levante a pélvis para a posição de ponte, alinhando com o tronco.'
                },
            ]
        },
        {
            ordem: 3,
            name: 'Posição gato assanhado',
            tipo: 'Repetições',
            category: ['Alongamento', 'Ganho de Amplitude Articular'],
            url: '/static/photos-exercises/3-gatoAssanhado.png',
            reps: 2,
            series: 1,
            descansoAposSerie: 11,
            descansoAposExercicio: 24,
            urlVideo: 'https://www.youtube.com/embed/KL6lQDiI1xo',
            tempoLimite: 'N.D',
            tempoManutencao: 'N.D',
            intensidade: 'Avançado',
            membros: ['Tronco'],
            instrucoes: [
                {
                    ordem: 1,
                    instrucao: 'Inicie na posição de quatro apoios, com as mãos à largura dos ombros e as costas em posição neutra. '
                },
                {
                    ordem: 2,
                    instrucao: 'Com as mãos bem apoiadas no chão, contraia os músculos abdominais e mantenha a coluna bem alinhada.'
                },
                {
                    ordem: 3,
                    instrucao: 'Inspire e flita o tronco, curvando para cima (convexidade para cima), e puxando a barriga para dentro. '
                },
                {
                    ordem: 4,
                    instrucao: 'Ao expirar, arqueie o tronco na direção oposta, baixe a barriga em direção ao chão e levante a cabeça. '
                },
                {
                    ordem: 5,
                    instrucao: 'Descanse alguns segundos e repita o movimento.'
                }
            ]
        },
        {
            ordem: 4,
            name: 'Rotação Lateral',
            tipo: 'Manutenção da postura',
            category: ['Alongamento'],
            url: '/static/photos-exercises/4-rotacaoLateral.png',
            reps: 4,
            series: 1,
            descansoAposSerie: 50,
            descansoAposExercicio: 30,
            urlVideo: 'https://www.youtube.com/embed/_bIL2oLwixI',
            tempoLimite: 'N.D',
            tempoManutencao: 'N.D',
            intensidade: 'Elementar',
            membros: ['Tronco'],
            instrucoes: [
                {
                    ordem: 1,
                    instrucao: 'Sentado numa cadeira, rode o tronco e a cabeça, olhando para trás, enquanto cruza a perna contralateral sobre a contrária. '
                },
                {
                    ordem: 2,
                    instrucao: 'Com o antebraço contralateral efetue pressão sobre a perna cruzada.'
                },
                {
                    ordem: 3,
                    instrucao: 'Regresse à posição inicial e de seguida rode para o lado contralateral repetindo o mesmo movimento.'
                },
            ]
        },
        {
            ordem: 5,
            name: 'Rotações dos MI, em decúbito dorsal',
            tipo: 'Repetições',
            category: ['Alongamento', 'Ganho de Amplitude Articular'],
            url: '/static/photos-exercises/rotacaoMI.png',
            reps: 2,
            series: 5,
            descansoAposSerie: 50,
            descansoAposExercicio: 60,
            urlVideo: 'https://www.youtube.com/embed/IiMLB1dZ45g',
            tempoLimite: 'N.D',
            tempoManutencao: 'N.D',
            intensidade: 'Intermédio',
            membros: ['Tronco'],
            instrucoes: [
                {
                    ordem: 1,
                    instrucao: 'Deite-se em decúbito dorsal com os joelhos dobrados e os pés bem assentes no chão.'
                },
                {
                    ordem: 2,
                    instrucao: 'Estenda os braços para os lados e mantenha os ombros bem apoiados no chão.'
                },
                {
                    ordem: 3,
                    instrucao: 'Mantenha os joelhos juntos e deixe-os cair para um lado rodando o tronco. '
                },
                {
                    ordem: 4,
                    instrucao: 'Volte à posição inicial e permita que os joelhos caiam para o lado oposto. '
                }
            ]
        },
        {
            ordem: 6,
            name: 'Alongamento isquiotibiais ',
            tipo: 'Manutenção de posição',
            category: ['Alongamento'],
            url: '/static/photos-exercises/alongamento_isquiotibiais.png',
            reps: 7,
            series: 44,
            descansoAposSerie: 15,
            descansoAposExercicio: 40,
            urlVideo: 'https://www.youtube.com/embed/iWFZ5NGV5JI',
            tempoLimite: 'N.D',
            tempoManutencao: 'N.D',
            intensidade: 'Intermédio',
            membros: ['Membros Inferiores'],
            instrucoes: [
                {
                    ordem: 1,
                    instrucao: 'Apoie o pé numa cadeira colocada em frente ao corpo. '
                },
                {
                    ordem: 2,
                    instrucao: 'Com ambos os joelhos em extensão tente chegar à ponta do pé apoiado na cadeira, com as suas mãos.'
                },
                {
                    ordem: 3,
                    instrucao: 'Simultaneamente puxe a ponta do mesmo pé na direção do corpo e sinta o alongamento na zona posterior da perna e coxa. '
                },
                {
                    ordem: 4,
                    instrucao: 'Aumente o avanço das mãos, gradualmente, até atingir a ponta do pé (preferencialmente).'
                },
                {
                    ordem: 5,
                    instrucao: 'Repita o procedimento com a perna contralateral.'
                },
            ]
        },
        {
            ordem: 7,
            name: 'Alongamento glúteo médio',
            tipo: 'Manutenção de Postura',
            category: ['Alongamento'],
            url: '/static/photos-exercises/alongamento-gluteo-medio.png',
            reps: 8,
            series: 3,
            descansoAposSerie: 14,
            descansoAposExercicio: 23,
            urlVideo: 'https://www.youtube.com/embed/TDPt5s3P3Bs',
            tempoLimite: 'N.D',
            tempoManutencao: 'N.D',
            intensidade: 'Avançado',
            membros: ['Membros Inferiores'],
            instrucoes: [
                {
                    ordem: 1,
                    instrucao: 'Cruze uma das pernas sobre a perna contralateral.'
                },
                {
                    ordem: 2,
                    instrucao: 'Incline o tronco sobre as pernas, como que as abraçando.'
                },
                {
                    ordem: 3,
                    instrucao: 'O pescoço deve acompanhar o movimento do tronco, fletindo durante o movimento.'
                },
            ]
        },
        {
            ordem: 8,
            name: 'Deadlift',
            tipo: 'Repetições',
            category: ['Reforço Muscular'],
            url: '/static/photos-exercises/deadlift.png',
            reps: 2,
            series: 5,
            descansoAposSerie: 19,
            descansoAposExercicio: 26,
            urlVideo: 'https://www.youtube.com/embed/Y4d9BvmOrsY',
            tempoLimite: 222,
            tempoManutencao: 11,
            intensidade: 'Elementar',
            membros: ['Tronco', 'Membros Inferiores'],
            instrucoes: [
                {
                    ordem: 1,
                    instrucao: 'Inicie na posição de pé, com os pés ligeiramente afastados e joelhos “destrancados”. '
                },
                {
                    ordem: 2,
                    instrucao: 'Mantendo as costas direitas (ombros para trás), desça o tronco na direção do chão, sem aumentar a flexão dos joelhos. '
                },
                {
                    ordem: 3,
                    instrucao: 'Execute todo o movimento promovendo a flexão das ancas. '
                },
                {
                    ordem: 4,
                    instrucao: 'Execute o movimento com ou sem carga.'
                }
            ]
        },
        {
            ordem: 9,
            name: 'Super-Homem',
            tipo: 'Repetições',
            category: ['Reforço Muscular', 'Coordenação'],
            url: '/static/photos-exercises/super-homem.png',
            reps: 2,
            series: 3,
            descansoAposSerie: 30,
            descansoAposExercicio: 40,
            urlVideo: 'https://www.youtube.com/embed/p7a1eneqpts',
            tempoLimite: 33,
            tempoManutencao: 2,
            intensidade: 'Avançado',
            membros: ['Tronco','Membros Superiores', 'Membros Inferiores'],
            instrucoes: [
                {
                    ordem: 1,
                    instrucao: 'Comece em posição de apoio, com uma linha reta da cabeça aos pés.'
                },
                {
                    ordem: 2,
                    instrucao: 'Olhe em frente e deixe os pés apoiados no chão e juntos.'
                },
                {
                    ordem: 3,
                    instrucao: 'Mantenha o corpo imóvel durante todo o movimento, levante um braço e a perna oposta.'
                },
                {
                    ordem: 4,
                    instrucao: 'Repeta usando o braço e perna opostos.'
                },
                {
                    ordem: 5,
                    instrucao: 'Tente manter o corpo o mais imóvel possível durante todo o exercício.'
                }
            ]
        },
        {
            ordem: 10,
            name: 'Abdominal com joelho e anca a 90º',
            tipo: 'Repetições',
            category: ['Reforço Muscular'],
            url: '/static/photos-exercises/abdominal.png',
            reps: 30,
            series: 10,
            descansoAposSerie: 30,
            descansoAposExercicio: 100,
            urlVideo: 'https://www.youtube.com/embed/Y4d9BvmOrsY',
            tempoLimite: 222,
            tempoManutencao: 111,
            intensidade: 'Avançado',
            membros: ['Tronco'],
            instrucoes: [
                {
                    ordem: 1,
                    instrucao: 'Inicie na posição de decúbito dorsal com os joelhos dobrados e os braços cruzados sobre o peito.'
                },
                {
                    ordem: 2,
                    instrucao: 'Mantenha a coluna lombar pressionada em direção ao chão. '
                },
                {
                    ordem: 3,
                    instrucao: 'Inspire e depois expire enquanto eleva os ombros do chão e olha em direção às coxas. '
                },
                {
                    ordem: 4,
                    instrucao: 'Mantenha os músculos abdominais contraídos enquanto enrola o tronco superior para cima. '
                },
                {
                    ordem: 5,
                    instrucao: 'Não permita que a coluna lombar se descole do chão. '
                },
                {
                    ordem: 6,
                    instrucao: 'Retorne lentamente para baixo enquanto controla o movimento para chegar à posição inicial.'
                }
            ]
        }
    ]
    },

    {
    id: 2,
    url: '/static/photos-exercises/lombalgia-subaguda.png',
    title: 'Fase 2',
    width: '33%',
    text: 'Plano particularmente adequado a situações em que os sintomas apresentam manifestação compreendida entre as quatro e doze semanas, decorrentes da evolução dos casos de sintomatologia em fase aguda. ',
    exercises: [
        {
            ordem: 1,
            name: 'Elevação de MI em 4 apoios',
            tipo: 'Repetições',
            category: ['Reforço Muscular'],
            url: '/static/photos-exercises/elevacao_MI_4apoios.png',
            reps: 8,
            series: 3,
            descansoAposSerie: 14,
            descansoAposExercicio: 23,
            urlVideo: 'https://www.youtube.com/embed/TDPt5s3P3Bs',
            tempoLimite: 'N.D',
            tempoManutencao: 'N.D',
            intensidade: 'Elementar',
            membros: ['Membros Inferiores'],
            instrucoes: [
                {
                    ordem: 1,
                    instrucao: 'Comece na posição de 4 apoios. '
                },
                {
                    ordem: 2,
                    instrucao: 'Mantenha as costas retas.'
                },
                {
                    ordem: 3,
                    instrucao: 'Contraia suavemente o assoalho pélvico e os músculos abdominais.'
                },
                {
                    ordem: 4,
                    instrucao: 'Sem mexer a coluna, levante lentamente uma perna para trás.'
                },
                {
                    ordem: 5,
                    instrucao: 'Retorne à posição inicial e repita o movimento com a perna contralateral.'
                },
                {
                    ordem: 6,
                    instrucao: 'Mantenha a coluna imóvel durante todo o movimento.',
                }
            ]
        },
        {
            ordem: 2,
            name: 'Ponte com flexão/extensão de joelhos na bola',
            tipo: 'Repetições',
            category: ['Reforço Muscular','Coordenação'],
            url: '/static/photos-exercises/ponteComFlexao.png',
            reps: 2,
            series: 5,
            descansoAposSerie: 19,
            descansoAposExercicio: 26,
            urlVideo: 'https://www.youtube.com/embed/Y4d9BvmOrsY',
            tempoLimite: 222,
            tempoManutencao: 11,
            intensidade: 'Elementar',
            membros: ['Tronco', 'Membros Inferiores'],
            instrucoes: [
                {
                    ordem: 1,
                    instrucao: 'Inicie na posição de decúbito dorsal com os calcanhares sobre a bola suíça.'
                },
                {
                    ordem: 2,
                    instrucao: 'Eleve a pélvis mantendo as pernas esticadas.'
                },
                {
                    ordem: 3,
                    instrucao: 'Mantenha essa posição, dobre os joelhos e role a bola na sua direção, aplicando uma pressão constante na bola com os calcanhares.'
                },
                {
                    ordem: 4,
                    instrucao: 'Volte à posição inicial, esticando as pernas, mas mantendo as ancas sempre elevadas.'
                }
            ]
        },
        {
            ordem: 3,
            name: 'ADM ativa para flexão do tronco ',
            tipo: 'Repetições',
            category: ['Ganho de amplitude articular', 'Alongamento'],
            url: '/static/photos-exercises/ADM_ativa.png',
            reps: 2,
            series: 3,
            descansoAposSerie: 30,
            descansoAposExercicio: 40,
            urlVideo: 'https://www.youtube.com/embed/p7a1eneqpts',
            tempoLimite: 33,
            tempoManutencao: 2,
            intensidade: 'Elementar',
            membros: ['Tronco'],
            instrucoes: [
                {
                    ordem: 1,
                    instrucao: 'Inicie na posição de pé com as pernas em extensão e à largura dos ombros.'
                },
                {
                    ordem: 2,
                    instrucao: 'Deslize lentamente as mãos pela parte da frente das coxas em direção aos pés.'
                },
                {
                    ordem: 3,
                    instrucao: 'Desça o máximo que conseguir de maneira confortável, mantendo as pernas em extensão.'
                },
                {
                    ordem: 4,
                    instrucao: 'Mantenha a posição, e depois retorne lentamente para a posição inicial.'
                }
            ]
        },
        {
            ordem: 4,
            name: 'Báscula da bacia, sentado na cadeira',
            tipo: 'Repetições',
            category: ['Coordenação', 'Ganho de Amplitude Articular'],
            url: '/static/photos-exercises/bascula-bacia.png',
            reps: 2,
            series: 3,
            descansoAposSerie: 30,
            descansoAposExercicio: 40,
            urlVideo: 'https://www.youtube.com/embed/p7a1eneqpts',
            tempoLimite: 33,
            tempoManutencao: 2,
            intensidade: 'Elementar',
            membros: ['Tronco'],
            instrucoes: [
                {
                    ordem: 1,
                    instrucao: 'Inicie sentado numa cadeira com as mãos nas ancas.'
                },
                {
                    ordem: 2,
                    instrucao: 'Enrole os ombros e a zona cervical para dentro, apoiando o peso sobre o sacro.'
                },
                {
                    ordem: 3,
                    instrucao: 'De seguida, estenda a coluna e leve o sacro para trás até sentir o apoio do peso sobre os ísquios abrindo o peito e trazendo os ombros para trás e para baixo. '
                }
            ]
        },
        {
            ordem: 5,
            name: 'Alongamento dinâmico de isquiotibiais',
            tipo: 'Repetições',
            category: ['Alongamento','Ganho de Amplitude Articular'],
            url: '/static/photos-exercises/Alongamento-Isquiotibiais.png',
            reps: 2,
            series: 3,
            descansoAposSerie: 30,
            descansoAposExercicio: 40,
            urlVideo: 'https://www.youtube.com/embed/p7a1eneqpts',
            tempoLimite: 33,
            tempoManutencao: 2,
            intensidade: 'Elementar',
            membros: ['Membros Inferiores'],
            instrucoes: [
                {
                    ordem: 1,
                    instrucao: 'Inicie com um joelho no chão e com um pé à frente, abaixo da linha do joelho.'
                },
                {
                    ordem: 2,
                    instrucao: 'Mantenha o corpo ereto, empurrando as ancas uniformemente para a frente até sentir um alongamento na parte da frente da coxa da perna de trás.  '
                },
                {
                    ordem: 3,
                    instrucao: 'De seguida, transfira o peso para trás, levando os glúteos em direção ao pé de trás, enquanto estica o joelho da frente e levanta os dedos dos pés. '
                },
                {
                    ordem: 4,
                    instrucao: 'Deverá sentir um alongamento na parte de trás da coxa da perna da frente. Continue alternando entre as duas posições.'
                }
            ]
        },
        {
            ordem: 6,
            name: 'Abraçar os joelhos em decúbito dorsal ',
            tipo: 'Manutenção de postura',
            category: ['Alongamento','Ganho de Amplitude Articular'],
            url: '/static/photos-exercises/AbracaoJoelhos.png',
            reps: 2,
            series: 3,
            descansoAposSerie: 30,
            descansoAposExercicio: 40,
            urlVideo: 'https://www.youtube.com/embed/p7a1eneqpts',
            tempoLimite: 33,
            tempoManutencao: 2,
            intensidade: 'Elementar',
            membros: ['Tronco'],
            instrucoes: [
                {
                    ordem: 1,
                    instrucao: 'Inicie na posição de decúbito dorsal. '
                },
                {
                    ordem: 2,
                    instrucao: 'Levante um pé e depois o outro.'
                },
                {
                    ordem: 3,
                    instrucao: 'Traga um joelho em direção ao peito e depois o outro.'
                },
                {
                    ordem: 4,
                    instrucao: 'Use as mãos para ajudar a abraçar as pernas, enrolando-se como uma bola.'
                }
            ]
        },
        {
            ordem: 7,
            name: 'Mountain Climbers',
            tipo: 'Repetições',
            category: ['Resistência', 'Condicionamento Geral'],
            url: '/static/photos-exercises/MountainClimbers.png',
            reps: 2,
            series: 3,
            descansoAposSerie: 30,
            descansoAposExercicio: 40,
            urlVideo: 'https://www.youtube.com/embed/p7a1eneqpts',
            tempoLimite: 33,
            tempoManutencao: 2,
            intensidade: 'Elementar',
            membros: ['Membros Inferiores','Tronco'],
            instrucoes: [
                {
                    ordem: 1,
                    instrucao: 'Inicie em posição de prancha, com os cotovelos estendidos e as mãos debaixo dos ombros.'
                },
                {
                    ordem: 2,
                    instrucao: 'Flita a anca para frente, trazendo o joelho fletido até ao peito e sustente a posição. '
                },
                {
                    ordem: 3,
                    instrucao: 'Estique a perna de volta para trás e repita o padrão de movimento do outro lado.'
                },
            ]
        },
        {
            ordem: 8,
            name: 'Abdominal “Dead bug”',
            tipo: 'Repetições',
            category: ['Reforço Muscular','Coordenação'],
            url: '/static/photos-exercises/deadBug.png',
            reps: 2,
            series: 3,
            descansoAposSerie: 30,
            descansoAposExercicio: 40,
            urlVideo: 'https://www.youtube.com/embed/p7a1eneqpts',
            tempoLimite: 33,
            tempoManutencao: 2,
            intensidade: 'Elementar',
            membros: ['Tronco', 'Membros Inferiores'],
            instrucoes: [
                {
                    ordem: 1,
                    instrucao: 'Inicie na posição de decúbito dorsal.'
                },
                {
                    ordem: 2,
                    instrucao: 'Dobre os joelhos e apoie os pés no chão. '
                },
                {
                    ordem: 3,
                    instrucao: 'Levante as pernas, uma de cada vez, mantendo os joelhos e as ancas a 90º, e estique ambos os braços colocando os ombros a 90º.  '
                },
                {
                    ordem: 4,
                    instrucao: 'Mantenha a coluna alinhada e acione os músculos abdominais durante o exercício. '
                },
                {
                    ordem: 5,
                    instrucao: 'Expire ao esticar uma perna para a frente o máximo possível e simultaneamente o braço homolateral para trás. '
                },
                {
                    ordem: 6,
                    instrucao: 'Inspire ao trazer a perna de volta à posição inicial.'
                },
                {
                    ordem: 7,
                    instrucao: 'Repita o movimento descrito do outro lado.'
                }
            ]
        },
        {
            ordem: 9,
            name: 'Prancha lateral ',
            tipo: 'Manutenção de postura',
            category: ['Reforço Muscular'],
            url: '/static/photos-exercises/PranchaLateral.png',
            reps: 2,
            series: 3,
            descansoAposSerie: 30,
            descansoAposExercicio: 40,
            urlVideo: 'https://www.youtube.com/embed/p7a1eneqpts',
            tempoLimite: 33,
            tempoManutencao: 2,
            intensidade: 'Elementar',
            membros: ['Tronco'],
            instrucoes: [
                {
                    ordem: 1,
                    instrucao: 'Deite de lado elevando-se sobre o cotovelo.'
                },
                {
                    ordem: 2,
                    instrucao: 'Mantenha as pernas esticadas uma sobre a outra.'
                },
                {
                    ordem: 3,
                    instrucao: 'Utilize o cotovelo e os pés para empurrar e eleve o corpo para longe do chão.'
                },
                {
                    ordem: 4,
                    instrucao: 'Mantenha uma linha reta da cabeça até os pés.'
                },
                {
                    ordem: 5,
                    instrucao: 'Mantenha esta posição pelo tempo descrito'
                }
            ]
        },
        {
            ordem: 10,
            name: 'Ponte com contração de adutores',
            tipo: 'Repetições',
            category: ['Reforço Muscular'],
            url: '/static/photos-exercises/ponteContracaoAdutores.png',
            reps: 2,
            series: 3,
            descansoAposSerie: 30,
            descansoAposExercicio: 40,
            urlVideo: 'https://www.youtube.com/embed/p7a1eneqpts',
            tempoLimite: 33,
            tempoManutencao: 2,
            intensidade: 'Elementar',
            membros: ['Tronco', 'Membros Inferiores'],
            instrucoes: [
                {
                    ordem: 1,
                    instrucao: 'Inicie na posição de decúbito dorsal com os joelhos fletidos e os pés bem apoiados no chão.'
                },
                {
                    ordem: 2,
                    instrucao: 'Aperte uma bola entre os joelhos.'
                },
                {
                    ordem: 3,
                    instrucao: 'Mantenha esta tensão durante todo o exercício, leve a zona pélvica para cima, alinhando com o tronco.'
                },
                {
                    ordem: 4,
                    instrucao: 'Continue a apertar enquanto baixa as costas para a posição inicial.'
                }
            ]
        }
    ]
    },
    {
    id: 3,
    url: '/static/photos-exercises/lombalgia-cronica.png',
    title: 'Fase 3',
    width: '33%',
    text: 'Plano particularmente adequado a situações em que os sintomas apresentam manifestação superior a doze semanas, decorrentes da evolução dos casos de sintomatologia em fase subaguda.',
    exercises: [
        {
            ordem: 1,
            name: 'Prancha frontal',
            tipo: 'Manutenção de postura',
            category: ['Reforço Muscular'],
            url: '/static/photos-exercises/pranchaFrontal.png',
            reps: 4,
            series: 1,
            descansoAposSerie: 50,
            descansoAposExercicio: 30,
            urlVideo: 'https://www.youtube.com/embed/_bIL2oLwixI',
            tempoLimite: 'N.D',
            tempoManutencao: 'N.D',
            intensidade: 'Elementar',
            membros: ['Tronco'],
            instrucoes: [
                {
                    ordem: 1,
                    instrucao: 'Inicie na posição de decúbito ventral de barriga e apoie os dedos dos pés no chão. '
                },
                {
                    ordem: 2,
                    instrucao: 'Coloque os antebraços no chão e empurre-se para cima, elevando o tronco e as pernas do chão.'
                },
                {
                    ordem: 3,
                    instrucao: 'Mantenha o alinhamento do corpo em linha reta, dos ombros até os pés, durante o tempo estabelecido.'
                },
                {
                    ordem: 4,
                    instrucao: 'Estabilize o tronco e o abdómen, de forma a evitar que as costas descaiam.'
                },
                {
                    ordem: 5,
                    instrucao: 'Mantenha também a contração dos glúteos e o alinhamento das ancas. Deverá sentir contração nos músculos abdominais.'
                }
            ]
        },
        {
            ordem: 2,
            name: 'Círculos da pélvis, em posição de pé',
            tipo: 'Repetições',
            category: ['Ganho de Amplitude Articular','Condicionamento Geral'],
            url: '/static/photos-exercises/circulosPelvis.png',
            reps: 2,
            series: 5,
            descansoAposSerie: 50,
            descansoAposExercicio: 60,
            urlVideo: 'https://www.youtube.com/embed/IiMLB1dZ45g',
            tempoLimite: 'N.D',
            tempoManutencao: 'N.D',
            intensidade: 'Elementar',
            membros: ['Tronco'],
            instrucoes: [
                {
                    ordem: 1,
                    instrucao: 'Inicie na posição de pé e mantenha os pés à largura das ancas. '
                },
                {
                    ordem: 2,
                    instrucao: 'Solte um pouco os joelhos. '
                },
                {
                    ordem: 3,
                    instrucao: 'Coloque as mãos sobre as ancas. '
                },
                {
                    ordem: 4,
                    instrucao: 'Inicie o movimento fazendo pequenos círculos com a pélvis. '
                },
                {
                    ordem: 5,
                    instrucao: 'Empurre as ancas para um lado e depois encaixe o sacro para dentro, trazendo as ancas para a frente.'
                },
                {
                    ordem: 6,
                    instrucao: 'De seguida, empurre as ancas para o outro lado. '
                },
                {
                    ordem: 7,
                    instrucao: 'Por fim, empurre as ancas para trás, levando o sacro para fora.'
                },
                {
                    ordem: 8,
                    instrucao: 'Faça movimentos fluídos, mantendo a parte superior do corpo e a cabeça imóveis. Aos poucos pode aumentar o tamanho do círculo, se for possível. '
                },
                {
                    ordem: 9,
                    instrucao: 'Repita para o outro sentido.'
                }
            ]
        },
        {
            ordem: 3,
            name: 'Extensão da lombar, em decúbito ventral ',
            tipo: 'Manutenção de postura',
            category: ['Reforço Muscular'],
            url: '/static/photos-exercises/extensaoLombar.png',
            reps: 7,
            series: 44,
            descansoAposSerie: 15,
            descansoAposExercicio: 40,
            urlVideo: 'https://www.youtube.com/embed/iWFZ5NGV5JI',
            tempoLimite: 'N.D',
            tempoManutencao: 'N.D',
            intensidade: 'Elementar',
            membros: ['Tronco'],
            instrucoes: [
                {
                    ordem: 1,
                    instrucao: 'Inicie na posição de decúbito ventral. '
                },
                {
                    ordem: 2,
                    instrucao: 'Dobre os cotovelos e pôr as mãos no alinhamento dos ombros.'
                },
                {
                    ordem: 3,
                    instrucao: 'Empurre a parte superior do seu corpo para cima colocando o tronco em extensão. '
                },
                {
                    ordem: 4,
                    instrucao: 'Mantenha as ancas e as coxas sempre no chão.'
                },
                {
                    ordem: 5,
                    instrucao: 'Contraia os glúteos durante todo o movimento.'
                },
                {
                    ordem: 6,
                    instrucao: 'Mantenha a posição durante o tempo indicado.'
                }
            ]
        },
        {
            ordem: 4,
            name: 'Agachamentos',
            tipo: 'Repetições',
            category: ['Reforço Muscular'],
            url: '/static/photos-exercises/agachamentos.png',
            reps: 2,
            series: 3,
            descansoAposSerie: 30,
            descansoAposExercicio: 40,
            urlVideo: 'https://www.youtube.com/embed/p7a1eneqpts',
            tempoLimite: 33,
            tempoManutencao: 2,
            intensidade: 'Elementar',
            membros: ['Membros Inferiores'],
            instrucoes: [
                {
                    ordem: 1,
                    instrucao: 'Inicie na posição de pé, mantendo os pés à largura dos ombros.'
                },
                {
                    ordem: 2,
                    instrucao: 'Ative os músculos abdominais e agachar suavemente. Não permita que os seus joelhos se desloquem muito para frente. Manter o peso nos calcanhares, não na ponta dos pés. '
                },
                {
                    ordem: 3,
                    instrucao: 'Contraia os glúteos quando estiver na posição mais baixa e mantenha-os tensos enquanto se levanta para a posição inicial. '
                },
            ]
        },
        {
            ordem: 5,
            name: 'Alongamento dinâmico de isquiotibiais com faixa elástica',
            tipo: 'Repeticoes',
            category: ['Alongamento', 'Ganho de Amplitude Articular'],
            url: '/static/photos-exercises/alongamentoDinamico.png',
            reps: 2,
            series: 3,
            descansoAposSerie: 30,
            descansoAposExercicio: 40,
            urlVideo: 'https://www.youtube.com/embed/p7a1eneqpts',
            tempoLimite: 33,
            tempoManutencao: 2,
            intensidade: 'Elementar',
            membros: ['Membros Inferiores'],
            instrucoes: [
                {
                    ordem: 1,
                    instrucao: 'Inicie na posição de decúbito dorsal e coloque uma cinta ao redor do pé de uma das pernas. '
                },
                {
                    ordem: 2,
                    instrucao: 'Puxe o joelho em direção ao peito e depois estique a perna em direção ao teto até sentir um alongamento na região posterior da coxa. '
                },
                {
                    ordem: 3,
                    instrucao: 'Repita o movimento com a perna contralateral.'
                }
            ]
        },
        {
            ordem: 6,
            name: 'Flexão lateral do tronco, em posição de pé',
            tipo: 'Repetições',
            category: ['Reforço Muscular', 'Ganho de Amplitude Articular', 'Alongamento'],
            url: '/static/photos-exercises/flexaoLateral.png',
            reps: 2,
            series: 3,
            descansoAposSerie: 30,
            descansoAposExercicio: 40,
            urlVideo: 'https://www.youtube.com/embed/p7a1eneqpts',
            tempoLimite: 33,
            tempoManutencao: 2,
            intensidade: 'Elementar',
            membros: ['Tronco'],
            instrucoes: [
                {
                    ordem: 1,
                    instrucao: 'Inicie na posição de pé com os pés à largura dos ombros.'
                },
                {
                    ordem: 2,
                    instrucao: 'Mantenha a coluna reta e olhar para a frente. Incline o tronco para um lado.'
                },
                {
                    ordem: 3,
                    instrucao: 'Deslize a mão ao lado da coxa e não faça flexão do tronco. '
                },
                {
                    ordem: 4,
                    instrucao: 'Depois de inclinar o máximo que conseguir, retorne lentamente para a posição inicial, controlando o movimento'
                }
            ]
        },
        {
            ordem: 7,
            name: 'Flexão do tronco, na posição sentada ',
            tipo: 'Manutenção de Posturas',
            category: ['Alongamento', 'Ganho de Amplitude Articular'],
            url: '/static/photos-exercises/FlexaoTronco.png',
            reps: 2,
            series: 3,
            descansoAposSerie: 30,
            descansoAposExercicio: 40,
            urlVideo: 'https://www.youtube.com/embed/p7a1eneqpts',
            tempoLimite: 33,
            tempoManutencao: 2,
            intensidade: 'Elementar',
            membros: ['Tronco'],
            instrucoes: [
                {
                    ordem: 1,
                    instrucao: 'Sentar alinhado numa cadeira e com os joelhos fletidos. '
                },
                {
                    ordem: 2,
                    instrucao: 'Fletir o tronco baixando a cabeça em direção aos joelhos. '
                },
                {
                    ordem: 3,
                    instrucao: 'Retorne à posição inicial e repita.'
                }
            ]
        },
        {
            ordem: 8,
            name: 'Ponte com apoio em uma perna',
            tipo: 'Repetições',
            category: ['Reforço Muscular', 'Coordenação'],
            url: '/static/photos-exercises/ponteApoio.png',
            reps: 2,
            series: 3,
            descansoAposSerie: 30,
            descansoAposExercicio: 40,
            urlVideo: 'https://www.youtube.com/embed/p7a1eneqpts',
            tempoLimite: 33,
            tempoManutencao: 2,
            intensidade: 'Elementar',
            membros: ['Membros Inferiores', 'Tronco'],
            instrucoes: [
                {
                    ordem: 1,
                    instrucao: 'Inicie em decúbito dorsal com as pernas afastadas à largura das ancas.'
                },
                {
                    ordem: 2,
                    instrucao: 'Dobre uma das pernas mantendo o pé apoiado no chão. '
                },
                {
                    ordem: 3,
                    instrucao: 'O joelho e o pé devem ficar alinhados com a anca homolateral. '
                },
                {
                    ordem: 4,
                    instrucao: 'Contraia os músculos abdominais e glúteos e eleve a zona pélvica, levantando a perna esticada. '
                },
                {
                    ordem: 5,
                    instrucao: 'Retorne à posição inicial e repita o movimento.'
                }
            ]
        },
        {
            ordem: 9,
            name: 'Báscula da bacia em decúbito dorsal',
            tipo: 'Repetições',
            category: ['Coordenação','Ganho de Amplitude Articular'],
            url: '/static/photos-exercises/bascula.png',
            reps: 2,
            series: 3,
            descansoAposSerie: 30,
            descansoAposExercicio: 40,
            urlVideo: 'https://www.youtube.com/embed/p7a1eneqpts',
            tempoLimite: 33,
            tempoManutencao: 2,
            intensidade: 'Elementar',
            membros: ['Tronco'],
            instrucoes: [
                {
                    ordem: 1,
                    instrucao: 'Inicie o movimento em decúbito dorsal com os joelhos fletidos e os pés bem apoiados no chão. '
                },
                {
                    ordem: 2,
                    instrucao: 'Puxe o umbigo em direção à coluna vertebral e contraia os glúteos para fazer o osso do sacro rolar, elevando-o do chão. A maior parte do esforço deve vir dos músculos abdominais e glúteos. A parte inferior das costas deve ser pressionada firmemente contra o chão.'
                },
                
            ]
        },
        {
            ordem: 10,
            name: 'Abdução da anca em posição lateral – ostra',
            tipo: 'repetições',
            category: ['Reforço Muscular', 'Ganho de Amplitude Articular'],
            url: '/static/photos-exercises/ostra.png',
            reps: 2,
            series: 3,
            descansoAposSerie: 30,
            descansoAposExercicio: 40,
            urlVideo: 'https://www.youtube.com/embed/p7a1eneqpts',
            tempoLimite: 33,
            tempoManutencao: 2,
            intensidade: 'Elementar',
            membros: ['Tronco'],
            instrucoes: [
                {
                    ordem: 1,
                    instrucao: 'Deite de lado com os pés, tornozelos e joelhos unidos. '
                },
                {
                    ordem: 2,
                    instrucao: 'Flita um pouco os joelhos e contraia os músculos do tronco. '
                },
                {
                    ordem: 3,
                    instrucao: 'Mantendo os pés juntos, levante o joelho de cima. Evite rodar o corpo para trás durante o movimento. '
                },
                {
                    ordem: 4,
                    instrucao: 'Retorne à posição inicial e repita.'
                },
            ]
        }
    ]
    }
];

export default dadosSessoes;